import request from './request'

export function search(data) {
    return request({
        url: '/api/product/search',
        method: 'get',
        params:data
    })
}

export function getCategoryList() {
    return request({
        url: '/api/product/getCategoryList',
        method: 'get'
    })
}

export function info(data) {
    return request({
        url: '/api/product/info',
        method: 'get',
        params:data
    })
}
